// export const enciteCMMCLevel1Courses = [
//   {
//     name: "CMMC Level 1 - Access Control (AC) - Authorized Access Control [FCI Data]",
//     image: require("../assets/images/encite/AAC-CMMC.png"),
//     description:
//       "Authorized Access Control (AC) focuses on implementing basic safeguards to ensure only authorized personnel can access Federal Contract Information (FCI). This involves establishing processes to identify and restrict access based on user roles and responsibilities, ensuring the protection of sensitive data. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
//     link: "https://student.encite.io/course-catalog/d84f79a0c7b26585f42c896bf4861558",
//   }, 
//   {
//     name: "CMMC Level 1 - Access Control (AC) - Transaction & Function Control",
//     image: require("../assets/images/encite/Transaction-Function.png"),
//     description:
//       "Access Control (AC) - Transaction & Function Control focuses on limiting access to specific transactions and functions involving Federal Contract Information (FCI). It ensures that only authorized users can perform tasks or operations based on their roles, helping to safeguard sensitive information. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
//     link: "https://student.encite.io/course-catalog/fce78adcd18fb80ee6c6fd0efb12bf51",
//   },
//   {
//     name: "CMMC Level 1 - External Connections [FCI Data]",
//     image: require("../assets/images/encite/External-connections.png"),
//     description:
//       "CMMC Level 1 - External Connections [FCI Data] focuses on securing external connections to systems that handle Federal Contract Information (FCI). It involves controlling and monitoring these connections to prevent unauthorized access and protect sensitive data during transmission. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19) ",
//     link: "https://student.encite.io/course-catalog/0b93c90f173a55a23228ea1b7ec7b5c3",
//   },
//   {
//     name: "CMMC Level 1 - Control Public Information [FCI Data]",
//     image: require("../assets/images/encite/Control-Public-Information.png"),
//     description:
//       "Control Public Information [FCI Data] ensures that Federal Contract Information (FCI) is not improperly disclosed to the public. It involves implementing processes to manage and protect sensitive data while sharing only authorized information. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
//     link: "https://student.encite.io/course-catalog/58a3ace8fa6b98471ed57e436bdd6a9b",
//   },
//   {
//     name: "CMMC Level 1 - Identification and Authentication [FCI Data]",
//     image: require("../assets/images/encite/Identification-Authentication.png"),
//     description:
//       "Identification and Authentication [FCI Data] ensures that only authorized individuals can access systems containing Federal Contract Information (FCI). This involves verifying user identities and enforcing basic authentication measures to protect sensitive data. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
//     link: "https://student.encite.io/course-catalog/8f7a9052fe74275e4800b5be3745f470",
//   },
//   {
//     name: "CMMC Level 1 - Media Disposal [FCI Data]",
//     image: require("../assets/images/encite/Media-Destruction.png"),
//     description:
//       "Media Disposal [FCI Data] focuses on securely disposing of media containing Federal Contract Information (FCI) to prevent unauthorized access. This includes properly destroying or sanitizing physical and digital media to protect sensitive data. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
//     link: "https://student.encite.io/course-catalog/9bfb774183eb9c2b6b1efc1836dcc586",
//   },
//   {
//     name: "CMMC Level 1 - Physical Protection [FCI Data]",
//     image: require("../assets/images/encite/Physical-Protection.png"),
//     description:
//       "Physical Protection [FCI Data] ensures the safeguarding of Federal Contract Information (FCI) through controlled physical access to facilities, systems, and equipment. It includes measures to prevent unauthorized entry and protect sensitive information from physical threats. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
//     link: "https://student.encite.io/course-catalog/d121fa7d97609f1614b3580145e428cb",
//   },
//   {
//     name: "CMMC Level 1 - Boundary Protection [FCI Data]",
//     image: require("../assets/images/encite/Boundary-Protection.png"),
//     description: "Boundary Protection [FCI Data] focuses on monitoring and controlling the flow of information between internal systems and external networks to safeguard Federal Contract Information (FCI). It includes implementing measures like firewalls and access controls to prevent unauthorized data access or transmission. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
//     link: "https://student.encite.io/course-catalog/3674ca455dff5d145cd7fc57975ab30c",
//   },
//   {
//     name: "CMMC Level 1 - Public Access System Separation",
//     image: require("../assets/images/encite/Public-Access-System.png"),
//     description:
//       "Public Access System Separation refers to the practice of isolating systems that handle public access from those containing sensitive or restricted information. This separation helps prevent unauthorized access to private data while ensuring that public-facing systems operate independently and securely. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
//     link: "https://student.encite.io/course-catalog/f02a42bb206594bee3feb184085e82dc",
//   },
//   {
//     name: "CMMC Level 1 - Flaw Remediation & Malicious Code Protection [FCI Data]",
//     image: require("../assets/images/encite/Flaw-remediation.png"),
//     description:
//       "Flaw Remediation & Malicious Code Protection [FCI Data] focuses on implementing measures to detect, flaws, prevent, and respond to malicious software while ensuring regular scanning of systems and files to maintain data security and integrity. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
//     link: "https://student.encite.io/course-catalog/eab3d463005c230ef3f7ffc1fd89a8a1",
//   },
//   {
//     name: "CMMC Level 1 - Update Malicious Code Protection and System/File Scanning for Federal Contract Information (FCI)",
//     image: require("../assets/images/encite/UpdateMaliciousCode.png"),
//     description: "Update Malicious Code Protection and System/File Scanning for Federal Contract Information (FCI) focuses on implementing measures to detect, prevent, and respond to malicious software while ensuring regular scanning of systems and files to maintain data security and integrity. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
//     link: "https://student.encite.io/course-catalog/e566efdb377e5f6e89757752cb5d72af",
//   },
// ];
export const enciteCMMCLevel1Courses = [
  {
    name: "CMMC Level 1 - Access Control (AC) - Authorized Access Control [FCI Data]",
    image: require("../assets/images/encite/AAC-CMMC.png"),
    description:
      "Authorized Access Control (AC) focuses on implementing basic safeguards to ensure only authorized personnel can access Federal Contract Information (FCI). This involves establishing processes to identify and restrict access based on user roles and responsibilities, ensuring the protection of sensitive data. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
    link: "https://encite.io/mod/scorm/view.php?id=252",
  },
  {
    name: "CMMC Level 1 - Access Control (AC) - Transaction & Function Control",
    image: require("../assets/images/encite/Transaction-Function.png"),
    description:
      "Access Control (AC) - Transaction & Function Control focuses on limiting access to specific transactions and functions involving Federal Contract Information (FCI). It ensures that only authorized users can perform tasks or operations based on their roles, helping to safeguard sensitive information. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
    link: "https://encite.io/mod/scorm/view.php?id=253",
  },
  {
    name: "CMMC Level 1 - External Connections [FCI Data]",
    image: require("../assets/images/encite/External-connections.png"),
    description:
      "CMMC Level 1 - External Connections [FCI Data] focuses on securing external connections to systems that handle Federal Contract Information (FCI). It involves controlling and monitoring these connections to prevent unauthorized access and protect sensitive data during transmission. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19) ",
    link: "https://encite.io/mod/scorm/view.php?id=248",
  },
  {
    name: "CMMC Level 1 - Control Public Information [FCI Data]",
    image: require("../assets/images/encite/Control-Public-Information.png"),
    description:
      "Control Public Information [FCI Data] ensures that Federal Contract Information (FCI) is not improperly disclosed to the public. It involves implementing processes to manage and protect sensitive data while sharing only authorized information. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
    link: "https://encite.io/mod/scorm/view.php?id=250",
  },
  {
    name: "CMMC Level 1 - Identification and Authentication [FCI Data]",
    image: require("../assets/images/encite/Identification-Authentication.png"),
    description:
      "Identification and Authentication [FCI Data] ensures that only authorized individuals can access systems containing Federal Contract Information (FCI). This involves verifying user identities and enforcing basic authentication measures to protect sensitive data. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
    link: "https://encite.io/mod/scorm/view.php?id=249",
  },
  {
    name: "CMMC Level 1 - Media Disposal [FCI Data]",
    image: require("../assets/images/encite/Media-Destruction.png"),
    description:
      "Media Disposal [FCI Data] focuses on securely disposing of media containing Federal Contract Information (FCI) to prevent unauthorized access. This includes properly destroying or sanitizing physical and digital media to protect sensitive data. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
    link: "https://encite.io/mod/scorm/view.php?id=247",
  },
  {
    name: "CMMC Level 1 - Physical Protection [FCI Data]",
    image: require("../assets/images/encite/Physical-Protection.png"),
    description:
      "Physical Protection [FCI Data] ensures the safeguarding of Federal Contract Information (FCI) through controlled physical access to facilities, systems, and equipment. It includes measures to prevent unauthorized entry and protect sensitive information from physical threats. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
    link: "https://encite.io/mod/scorm/view.php?id=251",
  },
  {
    name: "CMMC Level 1 - Boundary Protection [FCI Data]",
    image: require("../assets/images/encite/Boundary-Protection.png"),
    description: "Boundary Protection [FCI Data] focuses on monitoring and controlling the flow of information between internal systems and external networks to safeguard Federal Contract Information (FCI). It includes implementing measures like firewalls and access controls to prevent unauthorized data access or transmission. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
    link: "https://encite.io/mod/scorm/view.php?id=246",
  },
  {
    name: "CMMC Level 1 - Public Access System Separation",
    image: require("../assets/images/encite/Public-Access-System.png"),
    description:
      "Public Access System Separation refers to the practice of isolating systems that handle public access from those containing sensitive or restricted information. This separation helps prevent unauthorized access to private data while ensuring that public-facing systems operate independently and securely. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
    link: "https://encite.io/mod/scorm/view.php?id=254",
  },
  {
    name: "CMMC Level 1 - Flaw Remediation & Malicious Code Protection [FCI Data]",
    image: require("../assets/images/encite/Flaw-remediation.png"),
    description:
      "Flaw Remediation & Malicious Code Protection [FCI Data] focuses on implementing measures to detect, flaws, prevent, and respond to malicious software while ensuring regular scanning of systems and files to maintain data security and integrity. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
    link: "https://encite.io/mod/scorm/view.php?id=256",
  },
  {
    name: "CMMC Level 1 - Update Malicious Code Protection and System/File Scanning for Federal Contract Information (FCI)",
    image: require("../assets/images/encite/UpdateMaliciousCode.png"),
    description: "Update Malicious Code Protection and System/File Scanning for Federal Contract Information (FCI) focuses on implementing measures to detect, prevent, and respond to malicious software while ensuring regular scanning of systems and files to maintain data security and integrity. Version 2.13 | September 2024 DoD-CIO-00003 (ZRIN 0790-ZA19)",
    link: "https://encite.io/mod/scorm/view.php?id=255",
  },
];
export const enciteCMMCLevel2Courses = [
  {
    name: "CMMC Level 2 - Access Control: Part 1",
    image: require("../assets/images/encite/Privilege_and_access_Control.png"),
    description:
      "Access Control is an important security aspect of every organization. This course is the first of four to discuss this topic.",
    link: "https://encite.io/mod/scorm/view.php?id=218",
  },
  {
    name: "CMMC Level 2 - Access Control: Part 2",
    image: require("../assets/images/encite/LogonandUserSession.png"),
    description:
      "This second access control course will focus on how to handle user sessions from start to finish. Topics covered in this course include how to limit unsuccessful logon attempts.",
    link: "https://encite.io/mod/scorm/view.php?id=219",
  },
  {
    name: "CMMC Level 2 - Remote Access and Access Control",
    image: require("../assets/images/encite/RemoteAccess.png"),
    description:
      "At times it is necessary for employees to work remotely. In this third access control course, you will learn about the requirements to implement secure remote access.",
    link: "https://encite.io/mod/scorm/view.php?id=220",
  },
  {
    name: "CMMC Level 2 - Wireless and Mobile Access Control",
    image: require("../assets/images/encite/WirelessMobileAccess.png"),
    description:
      "Wireless access and the use of mobile devices are common occurrences within an organization. As the final course in our series on CMMC Level 2 Access Control, this course discusses access control as it relates to wireless and mobile access.",
    link: "https://encite.io/mod/scorm/view.php?id=221",
  },
  {
    name: "CMMC Level 2 - Security Awareness and Training",
    image: require("../assets/images/encite/SecurityAwareness.png"),
    description:
      "In this course, we will introduce three key controls focused on user security awareness and training: AT.L2-3.2.1 - Role-Based Risk Awareness, AT.L2-3.2.2 - Role-Based Training, and AT.L2-3.2.3 - Insider Threat Awareness.",
    link: "https://encite.io/mod/scorm/view.php?id=242",
  },
  {
    name: "CMMC Level 2 - Auditing and Accountability: Part 1",
    image: require("../assets/images/encite/Auditing-and-accountability-1.png"),
    description:
      "As you proceed through this course, you will discover how to retain audits, understand the necessary steps to hold users accountable, learn how to update procedures for specific recorded events, and learn failure processes in audits.",
    link: "https://encite.io/mod/scorm/view.php?id=230",
  },
  {
    name: "CMMC Level 2 - Auditing and Accountability: Part 2",
    image: require("../assets/images/encite/Auditing-and-accountability-2.png"),
    description:
      "As you go through this course, you will discover how to correlate audit information, learn the steps necessary to configure specific log details, synchronize systems for accuracy, protect your audit information, and uphold user privilege with audits.",
    link: "https://encite.io/mod/scorm/view.php?id=231",
  },
  {
    name: "CMMC Level 2 - Configuration Management: Part 1",
    image: require("../assets/images/encite/Configuration1.jpg"),
    description:
      "In our Configuration Management Part 1 course, we delve into establishing and maintaining configurations (CM.L2-3.4.1 - System Baselining), enforcing security settings (CM.L2-3.4.2 - Security Configuration Enforcement), managing system changes (CM.L2-3.4.3 - System Change Management), and analyzing security impacts (CM.L2-3.4.4 - Security Impact Analysis).",
    link: "https://encite.io/mod/scorm/view.php?id=240",
  },
  {
    name: "CMMC Level 2 - Configuration Management: Part 2",
    image: require("../assets/images/encite/Configuration2.jpg"),
    description:
      "As you go through this course, you will learn about the following: safeguarding against unauthorized modifications (CM.L2-3.4.5 - Access Restrictions for Change), minimal is more (CM.L2-3.4.6 - Least Functionality), why you should disable unnecessary functions (CM.L2-3.4.7 - Nonessential Functionality), the importance of excluding unnecessary software (CM.L2-3.4.8 - Application Execution Policy), and the benefits of limiting user installation power (CM.L2-3.4.9 - User-Installed Software).",
    link: "https://encite.io/mod/scorm/view.php?id=241",
  },
  {
    name: "CMMC Level 2 - Identification & Authentication: Part 1",
    image: require("../assets/images/encite/Identification-and-authentication-1.png"),
    description:
      "As you navigate this course, the Identification and Authentication (IA) controls serve as an important gateway to further practices within CMMC. It is important to understand and implement the requirements within this domain as they will help to solidify security and accountability within your organization.",
    link: "https://encite.io/mod/scorm/view.php?id=232",
  },
  {
    name: "CMMC Level 2 - Identification & Authentication: Part 2",
    image: require("../assets/images/encite/Identification-and-authentication-2.png"),
    description:
      "This is part 2 of Identification & Authentication of which will serve as a gateway to further practices within CMMC.",
    link: "https://encite.io/mod/scorm/view.php?id=233",
  },
  {
    name: "CMMC Level 2 - Incidence Response",
    image: require("../assets/images/encite/Incidenceresponse.jpg"),
    description:
      "Incident Response (IR) will serve as a motivating factor for remediating flaws in your infrastructure. It is important to understand and implement the requirements within this domain as it will help to solidify incident identification and reconciliation policies and controls within your organization. You will learn about incident handling, incident reporting, and incident response testing.",
    link: "https://encite.io/mod/scorm/view.php?id=229",
  },
  {
    name: "CMMC Level 2 - Maintenance",
    image: require("../assets/images/encite/Maintanence.jpg"),
    description:
      "Maintenance (MA) should be considered one of the most important security pillars within the organization. It is important to understand and implement the requirements within this domain as it will help to solidify security and accountability within your organization. This course covers key principles for securely conducting maintenance within your organization.",
    link: "https://encite.io/mod/scorm/view.php?id=227",
  },
  {
    name: "CMMC Level 2 - Media Protection: Part 1",
    image: require("../assets/images/encite/Media-protection-1.png"),
    description:
      "As you navigate this course, you will be introduced to protecting  system media containing CUI,  limiting access to CUI on system media to authorized users, marking  media, and controlling access to media. ",
    link: "https://encite.io/mod/scorm/view.php?id=234",
  },
  {
    name: "CMMC Level 2 - Media Protection: Part 2",
    image: require("../assets/images/encite/Mediaprotection2.png"),
    description:
      "As you investigate this course, you will be introduced to implementing cryptographic mechanisms, controlling the use of removable media on system components, prohibiting the use of portable storage devices, and protecting the confidentiality of backup CUI at storage locations.",
    link: "https://encite.io/mod/scorm/view.php?id=235",
  },
  {
    name: "CMMC Level 2 - Personnel Security",
    image: require("../assets/images/encite/Personal-Security.png"),
    description:
      "Personnel Security is one of the most important controls for an organization and its systems when it comes to protecting CUI and FCI from insider threats. It involves investigating individuals before authorizing access and protecting CUI from any actions performed by employees.",
    link: "https://encite.io/mod/scorm/view.php?id=236",
  },
  {
    name: "CMMC Level 2: Physical Protection",
    image: require("../assets/images/encite/Physical-Protection.png"),
    description:
      "Physical Protection is a mandatory control for an organization when it comes to protecting data from threats onsite or offsite. It involves monitoring and protecting the physical facility of an organization and protecting CUI when working at an alternative work site.",
    link: "https://encite.io/mod/scorm/view.php?id=239",
  },
  {
    name: "CMMC Level 2 - Risk Assessment",
    image: require("../assets/images/encite/Risk-assessment.png"),
    description:
      "In organizational security, Risk Assessment stands as a cornerstone, serving as an indispensable tool for continuous monitoring and risk management. It involves executing risk assessments, vulnerability scanning, and vulnerability remediation.",
    link: "https://encite.io/mod/scorm/view.php?id=237",
  },
  {
    name: "CMMC Level 2 - Security Assessment",
    image: require("../assets/images/encite/Security-assessment.png"),
    description:
      "Security Assessment controls introduce the importance of having the necessary documentation established within an organization. This helps to provide and declare the current security posture that the organization is currently putting forward.",
    link: "https://encite.io/mod/scorm/view.php?id=238",
  },
  {
    name: "CMMC Level 2 - System and Communication Protection: Part 1",
    image: require("../assets/images/encite/SysComm.png"),
    description:
      "This course is designed to develop the knowledge and skills needed to understand, implement, and assess the CMMC practices surrounding Security Engineering (SC.L2.-3.13.2), Role Separation (SC.L2-3.13.3), and Shared Resource Control (SC.L2-3.13.4).",
    link: "https://encite.io/mod/scorm/view.php?id=222",
  },
  {
    name: "CMMC Level 2 - System and Communication Protection: Part 2",
    image: require("../assets/images/encite/SysComm2.png"),
    description:
      "In this course, you will learn about the requirements for implementing and assessing CMMC practices Network Communication by Exception (SC.L2-3.13.6), Split Tunneling (SC.L2-3.13.7), and Connections Termination (SC.L2-3.13.9).",
    link: "https://encite.io/mod/scorm/view.php?id=223",
  },
  {
    name: "CMMC Level 2 - System and Communication Protection: Part 3",
    image: require("../assets/images/encite/SysComm3.png"),
    description:
      "In this course, you will learn about the requirements for implementing and assessing CMMC practices Collaborative Device Control (SC.L2-3.13.12),  Mobile Code ( SC.L2-3.13.13), and Voice Over Internet Protocol (SC.L2-3.13.14).",
    link: "https://encite.io/mod/scorm/view.php?id=224",
  },
  {
    name: "CMMC Level 2 - System and Communication Protection: Part 4",
    image: require("../assets/images/encite/SysComm4.png"),
    description:
      "In this course, you will learn about the requirements for implementing and assessing CMMC practices Key Management (SC.L2-3.13.10), CUI Encryption (SC.L2-3.13.11), Communications Authenticity (SC.L2-3.13.15), and Data at Rest (SC.L2-3.13.16).",
    link: "https://encite.io/mod/scorm/view.php?id=225",
  },
  {
    name: "CMMC Level 2 - System and Information Integrity",
    image: require("../assets/images/encite/SysComm5.png"),
    description:
      "In this course, you will learn about the requirements for implementing and assessing CMMC practices Security Alerts & Advisories (SI.L2-3.14.3), Monitor Communications for Attacks (SI.L2-3.14.6),  Identify Unauthorized Use (SI.L2-3.14.7).",
    link: "https://encite.io/mod/scorm/view.php?id=226",
  },
  {
    name: "Controlled Unclassified Information (CUI) for Contractors",
    image: require("../assets/images/encite/CUI.png"),
    description:
      "Welcome to the Controlled Unclassified Information (CUI) for Contractor's course. This course is designed to familiarize learners with CUI concepts to better educate them to safeguard CUI and to disseminate controls consistent with applicable laws, regulations, and government-wide policies.",
    link: "https://encite.io/mod/scorm/view.php?id=199",
  },
  {
    name: "Plan of Action and Milestones (POA&M)",
    image: require("../assets/images/encite/POAM.jpg"),
    description:
      "Welcome to the Plan of Action & Milestones (POA&M) course. This course is designed to familiarize learners and better educate businesses in effectively documenting, managing, and mitigating organizational risks, according to CMMC 2.0 applicable laws, regulations, and government-wide policies.",
    link: "https://encite.io/mod/scorm/view.php?id=203",
  },
  {
    name: "An Introduction to a System Security Plan (SSP) - Part 1",
    image: require("../assets/images/encite/SSP-Part1.png"),
    description:
      "Welcome to the System Security Plan (SSP) Introduction course. This course is designed to help the learners and businesses obtain a basic knowledge on what a System Security Plan is, why it is important and how an organization can develop, implement, and manage an SSP in their environment. Accountability from all related parties act as a crucial component for the success of the plan.",
    link: "https://encite.io/mod/scorm/view.php?id=201",
  },
  {
    name: "An Introduction to a System Security Plan (SSP) - Part 2",
    image: require("../assets/images/encite/SSP-Part1.png"),
    description:
      "Welcome to the System Security Plan (SSP) Introduction course. This course is designed to help the learners and businesses obtain a basic knowledge on what a System Security Plan is, why it is important and how an organization can develop, implement, and manage an SSP in their environment. Accountability from all related parties act as a crucial component for the success of the plan.",
    link: "https://encite.io/mod/scorm/view.php?id=217",
  },
];
export const enciteCMMCLevel3Courses = [];

export const enciteFOCICourses = [
  {
    name: "Understanding  Foreign Ownership, Control, or Influence (FOCI)",
    image: require("../assets/images/FOCI.jpeg"),
    description:
      "This course defines FOCI, explains what it means to be under FOCI, and details FOCI's effect on a company seeking initial or continued eligibility for access to a federally funded award.",
    link: "https://encite.io/mod/scorm/view.php?id=216",
  },
];